import {
  canPerformAction,
  type ValidationRequest,
  type WorkflowAction,
} from "@vv/requests-frontend";
import type { TeamRole } from "@vv/teams-frontend";

/**
 * Mirrors `RequestDetailPage`'s per-action gating exactly (same
 * `canPerformAction` plus the "must be the assigned engineer" / "must be the
 * original requestor" checks for the actions that need it) so a drag either
 * succeeds under the same rules the detail page's buttons already enforce,
 * or is rejected with a toast rather than silently failing server-side.
 */
export function canDragTo(
  action: WorkflowAction,
  request: ValidationRequest,
  isOwner: boolean,
  myTeamRoles: TeamRole[],
  currentUserId: string,
): boolean {
  if (!canPerformAction(action, isOwner, myTeamRoles)) return false;
  if (isOwner) return true;
  if (
    (action === "start" || action === "complete") &&
    !request.assignedEngineerIds.includes(currentUserId)
  ) {
    return false;
  }
  if (action === "requestRework" && request.requestorId !== currentUserId) {
    return false;
  }
  return true;
}
